var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Collapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7947 21.3334C11.9137 21.3306 12.0268 21.2816 12.1093 21.1969L17.65 15.7386L23.1908 21.1969C23.2328 21.2396 23.2831 21.2734 23.3386 21.2966C23.3942 21.3197 23.4539 21.3316 23.5142 21.3316C23.6039 21.3316 23.6915 21.3052 23.7659 21.2559C23.8403 21.2065 23.8981 21.1364 23.9318 21.0545C23.9655 20.9726 23.9737 20.8827 23.9552 20.7962C23.9367 20.7097 23.8925 20.6306 23.8282 20.5691L17.9687 14.7968C17.8842 14.7136 17.7696 14.6668 17.65 14.6668C17.5305 14.6668 17.4159 14.7136 17.3314 14.7968L11.4719 20.5691C11.4064 20.631 11.3613 20.7111 11.3428 20.7987C11.3242 20.8863 11.3329 20.9774 11.3678 21.06C11.4027 21.1426 11.4622 21.213 11.5383 21.2617C11.6145 21.3105 11.7039 21.3355 11.7947 21.3334Z",
    fill: "#0D5681"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#0D5681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Collapse);
export default __webpack_public_path__ + "static/media/icn_24x24_collapse.ffbeb55a27919e0db27a197d87440ec6.svg";
export { ForwardRef as ReactComponent };